import React from "react";
import PropTypes from "prop-types";
import { ItemType } from "@streamo/helper/types";
import { FunFact02 } from "gatsby-theme-component";

const FunFactArea = ({ data }) => (
    <section className="funfact-section bg-black section-space-ptb">
        <div className="container">
            <div className="counter-area sm:flex md:flex sm:justify-between md:justify-between">
                {data?.items?.map((item) => (
                    <FunFact02
                        key={item.id}
                        title={item?.title}
                        number={item?.number}
                    />
                ))}
            </div>
        </div>
    </section>
);

FunFactArea.propTypes = {
    data: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape(ItemType)),
    }),
};

export default FunFactArea;
